import React, { useState, useEffect, useRef } from 'react';
import Gallery from 'react-grid-gallery';
import './styles/App.scss';
import sections from './data';
import Signature from './Signature';
import Videos from './Videos';
import Slider from './Slider';

function App() {
  const [focusing, setFocusing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const searchInput = useRef(null);
  const contentElement = useRef(null);
  const [videos, setVideos] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);

  const onSearchBarFocus = () => {
    setFocusing(true);
  };

  const onSearchBarBlur = () => {
    // setFocusing(false);
  };

  useEffect(() => {
    setTimeout(() => {
      searchInput.current.focus();
    }, 1000);

    document.onkeydown = function(evt) {
      evt = evt || window.event;
      let isEscape = false;
      if ('key' in evt) {
        isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
      } else {
        isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
        setShowModal(false);
      }
    };
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
  }, [showModal]);

  const onSuggestionClick = (choice) => {
    if (choice === 'projects') {
      window.scrollTo({
        top: contentElement.current.offsetTop,
        behavior: 'smooth',
      });
      return;
    }
    
    const aWindow = window.open();
    aWindow.opener = null;

    switch(choice) {
      case 'linkedin': {
        aWindow.location = "https://www.linkedin.com/in/mvtuong/";
        break;
      }

      case 'code': {
        aWindow.location = "https://github.com/mai-cliqz";
        break;
      }

      case 'resume': {
        aWindow.location = "https://mvtuong.github.io/";
        break;
      }

      case 'contact': {
        aWindow.location = "mailto:wallepwa@gmail.com";
        break;
      }

      default: {
        break;
      }
    }
  };

  const onThumbnailClick = (event, list, source) => {
    event.preventDefault();
    event.stopPropagation();
    setVideos(list);
    setCurrentVideo(source);
    setShowModal(true);
  };

  return (
    <div className="App">
      {showModal &&
        <div className="Modal">
          <button className="CloseBtn" onClick={() => setShowModal(false)} />
          <Videos videos={videos} currentVideo={currentVideo} />
        </div>
      }
      <div className="Header">
        <div />
        <div className={`SearchContainter ${focusing ? 'focusing' : ''}`}>
          <Signature />
          <input
            type="search"
            className="SearchBar"
            placeholder="What are you looking for?"
            onFocus={onSearchBarFocus}
            onBlur={onSearchBarBlur}
            ref={searchInput}
            value=""
            onChange={() => {}}
          />
          <div className="SearchButtonWrapper">
            <button className="SearchButton" onClick={() => onSuggestionClick('projects')} />
          </div>
          <ul className="SearchSuggestions">
            <li role="presentation" onClick={() => onSuggestionClick('projects')}><span >I want to explore this <em>Page</em></span></li>
            <li role="presentation" onClick={() => onSuggestionClick('resume')}><span>I want to look at your <em>Profile</em></span></li>
            <li role="presentation" onClick={() => onSuggestionClick('code')}><span>I want to see your <em>Projects</em></span></li>
            <li role="presentation" onClick={() => onSuggestionClick('linkedin')}><span>I want to visit your <em>Linkedin</em></span></li>
            <li role="presentation" onClick={() => onSuggestionClick('contact')}><span>I want to contact <em>You</em></span></li>
          </ul>
        </div>
        <span className="ArrowDownBtn" onClick={() => onSuggestionClick('projects')} />
      </div>
      <div className="Content" ref={contentElement}>
        {sections.map(section =>
          <section key={section.title}>
            <table>
              <thead>
                <tr>
                  <th><em>Project Name</em></th>
                  <th><em>Period</em></th>
                  <th><em>Description</em></th>
                  <th><em>Responsibility</em></th>
                  <th><em>Tech Stack</em></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{section.title}</td>
                  <td>{section.time}</td>
                  <td>{section.description}</td>
                  <td>{section.responsible}</td>
                  <td>{section.techstack}</td>
                </tr>
              </tbody>
            </table>
            <div className="SliderWrapper">
              <Slider videos={section.videos} onThumbnailClick={onThumbnailClick} currentVideo={currentVideo} />
            </div>
            <Gallery
              id={section.title}
              images={section.images}
              enableImageSelection={false}
              backdropClosesModal={true}
              showLightboxThumbnails={true}
              rowHeight={140}
              margin={1}
              thumbnailStyle={() => ({ margin: '8px 0 0', height: 'calc(100% - 36px)', width: 'auto' })}
              tagStyle={{ cursor: 'default', color: '#999', fontSize: 12, fontWeight: 500, margin: '0 10px' }}
            />
          </section>
        )}
      </div>
      <div className="Footer">
      </div>
    </div>
  );
}

export default App;
